import { render } from "./Sdvplan.vue?vue&type=template&id=3cdbb760&scoped=true"
import script from "./Sdvplan.js?vue&type=script&lang=js"
export * from "./Sdvplan.js?vue&type=script&lang=js"

import "./Sdvplan.vue?vue&type=style&index=0&id=3cdbb760&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdbb760"]])

export default __exports__